module.exports = __webpack_public_path__ + "84c2aa2ead6631848a19b07122b59f63.svg";